import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import Typography from '../../components/Basics/Typography'
import { HEALTH_STATES } from './healthStatus'

const Y_AXIS_MAX = 24
const CHART_HEIGHT = 120
const AXIS_WIDTH = '70px'
const STRIP_MIN_WIDTH = '680px'

/**
 * The FleetHealthChart's component (view "Flota en el tiempo").
 * Client-side aggregation of the same strips: per cell, how many trucks are in
 * each state (cells with code -1 are ignored). Stacked DEGRADED → WATCH → HEALTHY
 * from the bottom up.
 */
const FleetHealthChart = ({ salud }) => {
  const { celdas = [], camiones = [], strips = {} } = salud

  const columns = celdas.map((cell, index) => {
    const counts = { healthy: 0, watch: 0, degraded: 0 }
    camiones.forEach(truck => {
      const code = (strips[truck] || [])[index]
      if (code === 0) counts.healthy += 1
      if (code === 1) counts.watch += 1
      if (code === 2) counts.degraded += 1
    })
    return { cell, counts }
  })

  const axisLabels = [celdas[0], celdas[Math.floor(celdas.length / 2)], celdas[celdas.length - 1]]
  const segmentHeight = count => `${(count / Y_AXIS_MAX) * 100}%`

  return (
    <Box style={{ marginTop: '30px' }}>
      <Typography variant="h2" margin="0 0 10px 0">
        Flota en el tiempo
      </Typography>
      <div style={{ overflowX: 'auto' }}>
        <div style={{ minWidth: STRIP_MIN_WIDTH }}>
          <div style={{ display: 'flex' }}>
            <div
              style={{
                width: AXIS_WIDTH,
                flexShrink: 0,
                height: `${CHART_HEIGHT}px`,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                fontSize: '11px',
                color: '#828282',
                paddingRight: '6px',
                textAlign: 'right',
                boxSizing: 'border-box'
              }}
            >
              <span>{Y_AXIS_MAX}</span>
              <span>{Y_AXIS_MAX / 2}</span>
              <span>0</span>
            </div>
            <div
              style={{
                display: 'flex',
                flex: 1,
                gap: '1px',
                height: `${CHART_HEIGHT}px`,
                borderBottom: '1px solid #E0E0E0'
              }}
            >
              {columns.map(({ cell, counts }, index) => (
                <div
                  key={`col-${index}`}
                  title={`${cell} · DEGRADED: ${counts.degraded} · WATCH: ${counts.watch} · HEALTHY: ${counts.healthy}`}
                  style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}
                >
                  <div style={{ height: segmentHeight(counts.healthy), backgroundColor: HEALTH_STATES[0].color }} />
                  <div style={{ height: segmentHeight(counts.watch), backgroundColor: HEALTH_STATES[1].color }} />
                  <div style={{ height: segmentHeight(counts.degraded), backgroundColor: HEALTH_STATES[2].color }} />
                </div>
              ))}
            </div>
          </div>
          <div style={{ display: 'flex', marginTop: '4px' }}>
            <span style={{ width: AXIS_WIDTH, flexShrink: 0 }} />
            <div
              style={{
                display: 'flex',
                flex: 1,
                justifyContent: 'space-between',
                fontSize: '11px',
                color: '#828282'
              }}
            >
              {axisLabels.map((label, index) => (
                <span key={`axis-${index}`}>{label}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Box>
  )
}

FleetHealthChart.propTypes = {
  salud: PropTypes.object.isRequired
}

export default FleetHealthChart
